// src/pages/PrivacyPolicy.jsx
import React from "react";

export default function PrivacyPolicy() {
  return (
    <div style={{ maxWidth: "900px", margin: "0 auto", padding: "24px" }}>
      <h1>Política de Privacidad de MyShopCity</h1>
      <p><strong>Última actualización:</strong> 12/11/2025</p>

      <p>
        Bienvenido a <strong>MyShopCity</strong>, una plataforma que conecta a compradores
        con comercios locales para facilitar compras rápidas y seguras dentro de su ciudad.
        En esta Política de Privacidad explicamos cómo recopilamos, usamos, almacenamos y
        protegemos la información personal de nuestros usuarios.
      </p>
      <p>
        Al utilizar la aplicación móvil, la web o el panel de administración de MyShopCity,
        usted acepta los términos descritos en este documento.
      </p>

      <h2>1. Responsable del tratamiento de datos</h2>
      <p>
        MyShopCity (&quot;la Plataforma&quot;, &quot;nosotros&quot;, &quot;nuestro&quot;) es
        responsable del tratamiento de los datos personales proporcionados por usuarios y
        vendedores al momento de utilizar la aplicación.
      </p>
      <p>
        Para consultas relacionadas con privacidad puede escribir a:<br />
        📧 <a href="myshopcity@gmail.com">myshopcity@gmail.com</a>
      </p>

      <h2>2. Datos que recopilamos</h2>
      <p>
        Para ofrecer el funcionamiento adecuado de la plataforma, MyShopCity recopila los
        siguientes tipos de datos:
      </p>

      <h3>2.1 Datos proporcionados por el usuario (comprador)</h3>
      <ul>
        <li>Nombre completo</li>
        <li>Dirección de entrega</li>
        <li>Número de teléfono</li>
        <li>Correo electrónico (para inicio de sesión)</li>
        <li>Ciudad y zona</li>
        <li>Información enviada en el chat con vendedores</li>
        <li>Historial de pedidos</li>
        <li>Notas o instrucciones de entrega</li>
      </ul>

      <h3>2.2 Datos proporcionados por el vendedor</h3>
      <ul>
        <li>Nombre completo del titular de la cuenta</li>
        <li>Nombre de la tienda</li>
        <li>Dirección comercial</li>
        <li>Teléfono de contacto</li>
        <li>Correo electrónico</li>
        <li>Identificación oficial (para verificación)</li>
        <li>Comprobante de domicilio (para verificación)</li>
        <li>Productos publicados (descripciones, precios, imágenes)</li>
        <li>Cuenta Stripe Connect para recibir pagos</li>
      </ul>

      <h3>2.3 Datos generados automáticamente</h3>
      <ul>
        <li>ID único de usuario</li>
        <li>Registros de actividad</li>
        <li>Tipo de dispositivo</li>
        <li>Sistema operativo</li>
        <li>Dirección IP aproximada</li>
        <li>Notificaciones generadas</li>
        <li>Tokens de notificaciones push</li>
        <li>Fecha y hora de uso</li>
        <li>Datos técnicos para seguridad y prevención de fraude</li>
      </ul>

      <p>
        <strong>
          No recolectamos información sensible como datos financieros del usuario directamente;
        </strong>{" "}
        todos los pagos se procesan bajo un entorno seguro mediante Stripe.
      </p>

      <h2>3. Uso de la información</h2>
      <p>Utilizamos los datos recopilados para:</p>

      <h3>3.1 Funciones esenciales de la plataforma</h3>
      <ul>
        <li>Crear cuentas de usuario y vendedor</li>
        <li>Enviar productos al domicilio proporcionado</li>
        <li>Mantener comunicación con vendedores mediante chat</li>
        <li>Procesar pedidos, entregas y devoluciones</li>
        <li>Enviar notificaciones sobre el estado del pedido</li>
        <li>Mostrar historial de compras</li>
        <li>Administrar productos, tiendas y publicaciones</li>
      </ul>

      <h3>3.2 Seguridad y cumplimiento</h3>
      <ul>
        <li>Prevención de fraude</li>
        <li>Verificación de vendedores</li>
        <li>Monitoreo de actividad sospechosa</li>
        <li>Cumplimiento de leyes aplicables</li>
      </ul>

      <h3>3.3 Mejoras de funcionamiento</h3>
      <ul>
        <li>Optimizar la experiencia del usuario</li>
        <li>Ajustar rutas de entrega</li>
        <li>Mejorar recomendaciones y contenido mostrado</li>
      </ul>

      <h2>4. Pagos y procesamiento financiero</h2>

      <h3>4.1 MyShopCity NO almacena ni procesa directamente datos bancarios</h3>
      <p>
        Todos los pagos se procesan exclusivamente mediante Stripe, un proveedor certificado
        bajo estándares internacionales como PCI-DSS.
      </p>

      <h3>4.2 Stripe Connect para vendedores</h3>
      <p>
        Los vendedores deberán crear una cuenta Stripe Connect para recibir pagos por ventas.
        La plataforma:
      </p>
      <ul>
        <li>
          Retiene el pago durante <strong>2 días</strong> mientras el comprador confirma el
          estado del producto.
        </li>
        <li>Si todo es correcto, Stripe libera el pago al vendedor.</li>
        <li>Si el comprador presenta una reclamación válida, MyShopCity evaluará el caso.</li>
      </ul>

      <h2>5. Compartición de información</h2>
      <p>
        MyShopCity <strong>NO</strong> vende ni comparte información personal con terceros
        ajenos a la operación de la plataforma.
      </p>
      <p>Podemos compartir datos únicamente cuando sea necesario para:</p>
      <ul>
        <li>Procesamiento de pagos (Stripe)</li>
        <li>Seguridad, verificación y cumplimiento legal</li>
        <li>Entregas locales administradas por repartidores autorizados</li>
      </ul>
      <p>
        En ningún caso compartimos correos, teléfonos o direcciones con empresas externas con
        fines publicitarios.
      </p>

      <h2>6. Derechos del usuario</h2>
      <p>El usuario puede:</p>
      <ul>
        <li>Acceder a su información personal</li>
        <li>Solicitar correcciones</li>
        <li>Solicitar la eliminación de su cuenta</li>
        <li>Retirar su consentimiento al uso de datos</li>
        <li>Solicitar información detallada de cómo usamos sus datos</li>
      </ul>
      <p>
        Para ejercer sus derechos puede escribir a:<br />
          <a href="myshopcity@gmail.com">myshopcity@gmail.com</a>
      </p>

      <h2>7. Conservación de la información</h2>
      <p>
        Conservamos los datos estrictamente el tiempo necesario para:
      </p>
      <ul>
        <li>Mantener el funcionamiento de las cuentas</li>
        <li>Cumplir obligaciones legales y fiscales</li>
        <li>Garantizar la seguridad de operaciones</li>
      </ul>

      <h2>8. Seguridad</h2>
      <p>Implementamos medidas como:</p>
      <ul>
        <li>Cifrado TLS/HTTPS</li>
        <li>Servidores seguros (Firebase + Stripe)</li>
        <li>Autenticación verificada (Firebase Auth)</li>
        <li>Control estricto de acceso interno</li>
        <li>Análisis de actividad sospechosa</li>
      </ul>
      <p>
        Ningún sistema es 100% infalible, pero seguimos estándares de seguridad internacionales.
      </p>

      <h2>9. Menores de edad</h2>
      <p>
        MyShopCity no está diseñada para menores de 18 años. No recopilamos intencionalmente
        datos de menores.
      </p>

      <h2>10. Cambios a esta Política</h2>
      <p>
        Podemos actualizar esta política ocasionalmente. Las nuevas versiones se publicarán en
        nuestra web/app.
      </p>
    </div>
  );
}
